import { render, staticRenderFns } from "./SuperAdminPrice.vue?vue&type=template&id=f28112a4"
import script from "./SuperAdminPrice.vue?vue&type=script&lang=js"
export * from "./SuperAdminPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports